"use strict";

jQuery(document).ready(function ($) {
  $('.people__cards').slick({
    autoplay: false,
    arrows: true,
    prevArrow: '<span class="people__arrow people__arrow--prev"></span>',
    nextArrow: '<span class="people__arrow people__arrow--next"></span>',
    speed: 400,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
    responsive: [{
      breakpoint: 1420,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 1080,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 900,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 640,
      settings: {
        slidesToShow: 1
      }
    }]
  });
});